import React, { useState, useEffect, useContext } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";

import SglContext from '../SglContext'
import './results.css';

import sgllogo from '../images/sgllogo.png'

function ShowChampions(props) {
    const [divisions, setDivisions] = useState([]);
    const [current_show, setCurrentShow] = useState(localStorage.getItem('show_id'));
    const [show_name, setShowName] = useState('');
    const [loading, setLoading] = useState(true);

    const Sgl = useContext(SglContext)

    const getChampionsData = (show) => {
        axios.get(Sgl.nestApiUrl + '/results/showChamps', {
            params: {
                show_id: show,
                customer_id: Sgl.company_id
            }
        }).then(res => {
            setDivisions(res.data.divisions)
            setCurrentShow(res.data.show_id)
            setShowName(res.data.show_name)
            setLoading(false)

            document.title = "Results for " + res.data.show_name;
            Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_path + '/' + show + '/showchampions');
            Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_path + '/' + show + '/showchampions');
        })
    }

    const getRiders = (riders_list) => {
        var data = [];

        riders_list.forEach(rider => {
            if (data.length == 0) {
                data.push(<Link to={'/people/detail?pid=' + rider.rider_id + '&sid=' + current_show}>
                    {rider.rider_name}
                </Link>)
            } else {
                data.push(', ');
                data.push(<Link to={'/people/detail?pid=' + rider.rider_id + '&sid=' + current_show}>
                    {rider.rider_name}
                </Link>)
            }
        });

        return data;
    }

    useEffect(() => {
        getChampionsData(props.currentShow)
    }, [props.currentShow]); // add props as dependencies

    // useEffect(() => { // ComponentDidMount
    //     getChampionsData(current_show)
    // }, [])

    if (loading) {
        return null;
    }

    return (
        <div id='section-to-print' className="section-to-print resultscss">
               <section className="search-area">
            <h2 className="sgl-h2">Results for {show_name}</h2>
            <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
            {(divisions.length > 0) ?
                <div>
                    <div>
                        <a className='result_print no_print' onClick={() => window.print()}><img className='printer-icon' src={require('../images/printer.png')} /> Print</a>
                        <h2 className='center-align'>Show Champions and Reserve Champions</h2>
                    </div>
                    <div className="flex-champ-container">
                        {
                            divisions.map((division, idx) => (
                                <div className="champ_container" style={{overflow: "hidden"}} key={idx}>
                                    <div key={division} className="" style={{ height: '100%' }}>
                                        <div className='' style={{ height: '100%', overflow: "hidden" }}>
                                            <table className="table table-striped table-hover champions_table">
                                                <thead>
                                                    <tr className="sgl-primary-header">
                                                        <th colSpan="3">{division.name}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th></th>
                                                        <th>Horse</th>
                                                        <th>Rider</th>
                                                    </tr>
                                                    {
                                                        division.champions.map((data, index) => {
                                                            return (
                                                                <tr className="sgl-anchor">
                                                                    <td><b>{data.type}</b></td>
                                                                    <td><Link to={'/entries/detail?eid=' + data.entry_id + '&sid=' + current_show}>
                                                                        {data.horse}
                                                                    </Link></td>
                                                                    <td>{
                                                                        getRiders(data.riders)
                                                                    }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th colSpan="3" className="view_division_result" >
                                                            <Link to={'/results/detail?div_id=' + division.division_id + '&sid=' + current_show}>View Division Results</Link>
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                :
                <table>
                    <tbody>
                        <tr>
                            <td>No records found.</td>
                        </tr>
                    </tbody>
                </table>
            }

            
            {/* <div id="print_footer" className="print_block print_footer">
            </div>
            <div className="copyright-text no_print">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </div> */}
        <div id="print_footer" className="print_block print_footer">
            <img className='footer_logo' src={sgllogo} />Copyright © {(new Date().getFullYear())} · All rights reserved · ShowGrounds, LLC. · Shelburne Falls MA · 1-888-429-9495     
            </div>
            <div className="copyright-text no_print">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </section>
        </div>
    )
}

export default ShowChampions;